<template>
  <div class="recommend-page">
    <Banner :bannerUrl="bannerUrl" title="内部推荐" />
    <div class="submit-form">
      <a-form
        :model="formState"
        name="basic"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
        labelAlign="left"
        autocomplete="off"
        @finish="onFinish"
        @finishFailed="onFinishFailed"
      >
        <a-form-item
          label="推荐人姓名"
          name="username"
          :rules="[{ required: true, message: '请输入推荐人姓名' }]"
        >
          <a-input v-model:value="formState.username" />
        </a-form-item>
        <a-form-item
          label="推荐人手机号"
          name="username"
          :rules="[{ required: true, message: '请输入推荐人姓名' }]"
        >
          <a-input v-model:value="formState.username" />
        </a-form-item>
        <a-form-item
          label="被推荐人姓名"
          name="username"
          :rules="[{ required: true, message: '请输入推荐人姓名' }]"
        >
          <a-input v-model:value="formState.username" />
        </a-form-item>
        <a-form-item
          label="被推荐人手机号"
          name="username"
          :rules="[{ required: true, message: '请输入推荐人姓名' }]"
        >
          <a-input v-model:value="formState.username" />
        </a-form-item>
        <a-form-item
          label="应聘岗位"
          name="username"
          :rules="[{ required: true, message: '请输入推荐人姓名' }]"
        >
          <a-input v-model:value="formState.username" />
        </a-form-item>
        <a-form-item
          label="推荐人与被推荐人关系"
          name="username"
          :rules="[{ required: true, message: '请输入推荐人姓名' }]"
        >
          <a-input v-model:value="formState.username" />
        </a-form-item>
        <a-form-item
          label="简历附件"
          name="username"
          :rules="[{ required: true, message: '请输入推荐人姓名' }]"
        >
          <a-upload
            v-model:file-list="fileList"
            :showUploadList="false"
            name="file"
            :maxCount="1"
            @change="handleChange"
          >
            <a-input v-model:value="formState.file" readonly placeholder="请上传" />
            <a-button type="primary" class="fc"><FolderOpenOutlined />选择</a-button>
          </a-upload>
        </a-form-item>
        <a-button class="submit-btn" type="primary">申请职位</a-button>
      </a-form>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Banner from '@/components/banner'
import { FolderOpenOutlined } from '@ant-design/icons-vue'
const bannerUrl = require('@assets/images/banner/banner-recommend.png');
const formState = ref({});
const fileList = ref([]);
const handleChange = () => {};
</script>

<style lang="less" scoped>
.recommend-page {
  background: #F7F7F7;
  /deep/ .com-banner .banner_title {
    left: 50%;
    transform: translate(-50%, 40px);
    font-size: 32px;
  }
  .submit-form {
    position: relative;
    z-index: 2;
    width: 996px;
    border-radius: 8px;
    background: #FFF;
    margin: 0 auto;
    padding: 46px 77px;
    transform: translate(0, -115px);

    /deep/ .ant-form {
      .ant-form-item {
        margin-bottom: 34px;
        .ant-form-item-label >label {
          color: #25262C;
          font-size: 14px;
        }
      }
      .ant-form-item-control .ant-form-item-control-input-content .ant-input {
        height: 42px;
        border-radius: 4px;
        border: 1px solid #DBDBDB;
      }
      .ant-upload-wrapper, .ant-upload {
        display: flex;
        width: 100%;
        gap: 12px;
        .ant-btn-primary {
          width: 89px;
          height: 42px;
          border-radius: 4px!important;
          .anticon-folder-open {
            font-size: 18px;
          }
        }
      }
    }
    .submit-btn {
      width: 100%;
      height: 50px;
      background: #3071FF;
      font-size: 14px;
      font-weight: 500;
      margin-top: 17px;
    }
  }
}
</style>